// 锁定webview，隐藏标题栏
/* eslint-disable */
function suo () {
  cordova.exec(function (data) {
    resolve(data)
    console.log('锁死webview成功')
  }, function () {
    reject()
    console.log('锁死webview失败')
  }, 'MideaCommon', 'setBounces', [0])
}

function allReady () {
  return new Promise(function (resolve) {
    document.addEventListener('deviceready', function () {
      suo()
    }, false)
  })
}

export default allReady()
